module.exports = __webpack_public_path__ + "static/img/imgs1.b14ac5a8.jpg";